import { AddressDTO } from "./addressDTO";

export class VendorDTO{
    public id!:number;
    public name!:string;
    public addressList!: AddressDTO[];
    public premierPartnerIdList!: number[];
    public billingBucketIdList!: number[];
    public billingCustomerId?:string;
    public deleted?:boolean;
    public canCreateMoovs!:boolean;
    public added?:string;

    constructor(){
        this.addressList = new Array();
        this.premierPartnerIdList = new Array();
        this.billingBucketIdList = new Array();
    }
}